module.exports = __webpack_public_path__ + "img/dedikovany-win-server.66d20b6f.svg";